import { useEffect, useRef } from "react";

type Props = {
  /** e.g. "Ryan" */
  brandName: string;
  /** logo to show above the headline (optional) */
  logoUrl?: string;
  /** auto-rotate interval (ms) */
  intervalMs?: number;
};

const RyanLoginCarouselControl: React.FC<Props> = ({
  brandName,
  logoUrl,
  intervalMs = 5000,
}) => {
  const carouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    const timer = setInterval(() => {
      const slides = el.querySelectorAll<HTMLDivElement>(".carousel-item");
      if (!slides.length) return;

      const active =
        el.querySelector<HTMLDivElement>(".carousel-item.active") || slides[0];
      const activeIndex = Array.from(slides).indexOf(active);
      const nextIndex = (activeIndex + 1) % slides.length;

      active.classList.remove("active");
      slides[nextIndex].classList.add("active");

      const dots = el.querySelectorAll<HTMLButtonElement>(".status-btn");
      dots.forEach((d) => d.classList.remove("active"));
      if (dots[nextIndex]) dots[nextIndex].classList.add("active");
    }, intervalMs);

    return () => clearInterval(timer);
  }, [intervalMs]);

  return (
    <div className="d-flex flex-column justify-content-center w-75 text-center align-items-center">
      {logoUrl && (
        <img
          src={logoUrl}
          width={100}
          height='auto'
          className="mb-3"
          alt={`${brandName} logo`}
        />
      )}
      <h2>Welcome To {brandName} Alumni Network</h2>

      <div id="carouselLogin" className="carousel slide" ref={carouselRef}>
        <div className="carousel-indicators">
          {[0, 1, 2, 3].map((i) => (
            <button
              key={i}
              type="button"
              data-bs-target="#carouselLogin"
              data-bs-slide-to={i}
              className={`status-btn bg-danger ${i === 0 ? "active" : ""}`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        <div className="carousel-inner mb-5">
          <div className="carousel-item active">
            <figure>
              <img
                className="mx-auto"
                src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/login_img01.webp"
                alt=""
              />
            </figure>
            <h4>Connect</h4>
            <p>
              Build your own network of connections by reaching out to your
              school seniors, juniors, and faculty on our Alumni platform.
            </p>
          </div>

          <div className="carousel-item">
            <figure>
              <img
                className="mx-auto"
                src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/login_img02.webp"
                alt=""
              />
            </figure>
            <h4>Stay Updated</h4>
            <p>
              Are you curious about what’s happening at your school? Always stay
              in the loop as an alumni member. From webinars to events and
              achievements, get notified on it all!
            </p>
          </div>

          <div className="carousel-item">
            <figure>
              <img
                className="mx-auto"
                src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/login_img03.webp"
                alt=""
              />
            </figure>
            <h4>Contribute</h4>
            <p>
              You have grown with us and transformed into what you are today.
              This is your chance to give back and contribute by helping
              students in their careers, conducting webinars and much more!
            </p>
          </div>

          <div className="carousel-item">
            <figure>
              <img
                className="mx-auto"
                src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/login_img04.webp"
                alt=""
              />
            </figure>
            <h4>Upskill</h4>
            <p>
              Upskilling is the key to growth! This platform offers you unique
              tips and opportunities to scale up your career. Use them to make a
              huge impact!
            </p>
          </div>
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselLogin"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselLogin"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default RyanLoginCarouselControl;
